import React from 'react';
import { Spinner } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import { pxToRem } from '@withjoy/joykit/theme';
import { useResponsive } from '@shared/utils/hooks/useResponsive';
import { useFormControl } from '@withjoy/joykit/components/FormControl/FormControl.provider';

import { PoweredByGoogle } from '../LocationInput/PoweredByGoogle';
import { LocationInputV2SelectV1 } from './LocationInputV2SelectV1';
import { LocationInputV2Props, useLocationInputV2 } from './LocationInputV2.controller';

const AUTOSELECT_DROPDOWN_HEIGHT = 315;
// On IOS browser auto select drop-down override on input field b/c of not have enough space. Minimized height in mobile
const AUTOSELECT_DROPDOWN_HEIGHT_MOBILE = 240;

export const LocationInputV2 = <T extends {}>(props: LocationInputV2Props<T>) => {
  const { t } = useTranslation('joykit');
  const { noOptionsMessage = t('locationInput', 'noOptionsMessage')() } = props;
  const { options, inputValue, handleInputValue, handleChange, iconRight, iconLeft, onLocationOpen, onLocationClose, placeholder } = useLocationInputV2(props);
  const formControlProps = useFormControl({});
  const [isMobile] = useResponsive({ values: { mobile: true, tablet: false } });

  return (
    <LocationInputV2SelectV1
      noBorder={props.noBorder}
      placeholder={placeholder ? placeholder : 'San Francisco, CA'}
      options={options}
      inputValue={inputValue}
      noOptionsMessage={noOptionsMessage}
      searchable
      isInvalid={formControlProps.isInvalid}
      onChange={handleChange}
      onMenuOpen={onLocationOpen}
      onMenuClose={onLocationClose}
      optionFilter={() => true}
      iconRight={iconRight}
      iconLeft={iconLeft}
      onInputChange={handleInputValue}
      loadingMessage={() => <Spinner />}
      autoComplete="off"
      isHideListItemIcon={props.isHideListItemIcon}
      afterMenuContent={<PoweredByGoogle />}
      maxDropdownHeight={props.maxDropdownHeight ? props.maxDropdownHeight : isMobile ? pxToRem(AUTOSELECT_DROPDOWN_HEIGHT_MOBILE) : pxToRem(AUTOSELECT_DROPDOWN_HEIGHT)}
      disabled={props.disabled}
    />
  );
};
